/* Rarity tier display colors for badges and UI. */

import type { Rarity } from "@/types/kiwiSkin";

export const RARITY_COLORS: Record<Rarity, string> = {
  Common: "#9e9e9e",
  Uncommon: "#4caf50",
  Rare: "#2196f3",
  Epic: "#9c27b0",
  Legendary: "#ff9800",
};
